export default __webpack_public_path__ + "static/media/Inhaler 2.583a0be9.png";